<app-header></app-header>
<app-menu></app-menu>
<div class="col-md-12" style="top: 10vh;">
    <iframe id="viewpp" name="someFrame"  frameborder="0" class="col-md-12" style="height: 100vh;width: 90vw;">
   
    
    </iframe>
</div>